import { Controller, useFormContext } from "react-hook-form";
import Select from "@/components/Select";
import { ProductsFormValues } from "../types";

interface ProductOption {
  value: string;
  displayText: string;
  description?: string;
}

interface ProductsDropdownProps {
  index: number;
  disabled?: boolean;
  products: Array<ProductOption>;
  loading?: boolean;
  supportingText?: string;
}

const ProductsDropdown = ({ index, disabled, products = [], supportingText }: ProductsDropdownProps) => {
  const {
    control,
    setValue,
    clearErrors,
    trigger,
    formState: { errors }
  } = useFormContext<ProductsFormValues>();

  return (
    <Controller
      name={`products.${index}.id`}
      control={control}
      render={({ field: { value } }) => (
        <Select
          label="Product"
          options={products}
          className="w-full"
          value={value}
          disabled={disabled || products.length <= 1}
          supportingText={supportingText}
          onSelect={(value) => {
            setValue(`products.${index}.variantId`, "");
            setValue(`products.${index}.variantName`, "");
            setValue(`products.${index}.variantPrice`, 0);
            setValue(`products.${index}.collection`, "registration");
            setValue(`products.${index}.id`, value);
            clearErrors(`products.${index}.id`);
            trigger(`products.${index}.id`);
          }}
          required
          data-testid={`product-select-${index}`}
          error={!!errors.products?.[index]?.id}
          errorText={errors.products?.[index]?.id?.message as string}
        />
      )}
    />
  );
};

export default ProductsDropdown;
